/**
 * Detects if the app is running in V0 preview environment
 */
export function isV0Preview(): boolean {
  if (typeof window === 'undefined') return false;
  
  // Check if we're in an iframe (V0 preview runs in iframe)
  const isInIframe = window !== window.parent;
  
  // Check for V0 specific URLs or domains
  const isV0Domain = window.location.hostname.includes('v0.dev') || 
                    window.location.hostname.includes('lite.vusercontent.net');
  
  // Check for V0 specific query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const hasV0Params = urlParams.has('__v0_token') || 
                     window.location.pathname.includes('v0');
  
  return isInIframe || isV0Domain || hasV0Params;
}

/**
 * Gets the appropriate base URL for the current environment
 */
export function getBaseUrl(): string {
  // In V0 preview, we should use relative URLs to avoid CORS issues
  // The V0 preview runs on a Vercel domain, so we need to make API calls to the same domain
  if (isV0Preview()) {
    return '';
  }
  
  // In production or test, use the configured URL
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
    return process.env.NEXT_PUBLIC_APP_URL || 'https://dev.crm.thekautapengroup.com';
  }
  
  // In development, use relative URLs
  return '';
}

/**
 * Adjusts authentication behavior for V0 preview
 */
export function getAuthConfig() {
  const isV0 = isV0Preview();
  
  return {
    // In V0 preview, we might need to adjust token storage
    useSecureStorage: !isV0,
    // In V0 preview, we might need to adjust API calls
    apiBaseUrl: isV0 ? getBaseUrl() : '',
    // In V0 preview, we might need to adjust redirects
    allowRedirects: !isV0,
  };
}
